import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import Counter from './components/Counter';
import FetchData from './components/FetchData';
import RequiredAuth from './components/RequireAuth';
import Signin from './components/auth/Signin';
import ListShortLists from './components/ListShortLists';
import GenericLists from './components/Lists';
import Release from './components/Release';
import Utilities from './components/Utilities';
import Tags from './components/Tags';
import DownloadArtworks from './components/DownloadArtworks';
import UpdateProducts from './components/UpdateProducts';
import Sync from './components/Sync';
import MLTags from './components/TagsML';
export default () => (
    <Layout>
        <Route exact path='/' component={RequiredAuth(Home)} />
    <Route path='/counter' component={Counter} />
        <Route path='/fetch-data/:startDateIndex?' component={FetchData} />
        <Route path='/Lists/' component={RequiredAuth(GenericLists)}/>
        <Route path='/Signin' component={Signin} />
        <Route path='/Releases' component={RequiredAuth(Release)} />
        <Route path='/utilities' component={RequiredAuth(Utilities)} />
        <Route path='/tags' component={RequiredAuth(Tags)} />
        <Route path='/Artworks' component={RequiredAuth(DownloadArtworks)} />
        <Route path='/Update' component={RequiredAuth(UpdateProducts)} />
        <Route path='/Sync' component={RequiredAuth(Sync)} />
        <Route path='/ML' component={RequiredAuth(MLTags)} />
  </Layout>
);



// WEBPACK FOOTER //
// ./src/App.js